module.exports = __webpack_public_path__ + "img/yaku-user.b47fcd8f.png";